import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'

type AnyConversationPayload = IConversationTypeInterfacesMap[ConversationType]['conversationTypePayload']
type DatabaseFilePayload = IConversationTypeInterfacesMap[ConversationType.DatabaseFile]['conversationTypePayload']

export function useDatabaseFileConversationTypeStrategy() {
  const getConversationKey = (payload: AnyConversationPayload): string => {
    const typed = payload as DatabaseFilePayload
    return `${typed.databaseItemId}-${typed.databasePropertyId}-${typed.databaseItemFileId}`
  }

  const getRelayConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as DatabaseFilePayload).databaseItemFileId
  }

  return {
    getConversationKey,
    getRelayConversationKey,
  }
}
